export default "__VITE_ASSET__DfdmB6Jh__"